export default "__VITE_ASSET__CO209STp__"